import { render, staticRenderFns } from "./NexosNotificationModal.vue?vue&type=template&id=0d45043a"
import script from "./NexosNotificationModal.vue?vue&type=script&lang=js"
export * from "./NexosNotificationModal.vue?vue&type=script&lang=js"
import style0 from "./NexosNotificationModal.vue?vue&type=style&index=0&id=0d45043a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports